import { useNavigate } from "react-router-dom";
import { useState } from "react";

function AddCampaign() {
  const navigate = useNavigate();
  const [name, setName] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    // Later connect to backend
    navigate("/campaigns/1");
  };

  return (
    <div className="max-w-xl mx-auto bg-white p-6 rounded-xl shadow-sm space-y-6">

      <h1 className="text-xl font-semibold text-gray-800">
        Create Campaign
      </h1>

      <form onSubmit={handleSubmit} className="space-y-4">

        <div>
          <label className="block text-sm font-medium mb-2">
            Campaign Name
          </label>
          <input
            type="text"
            required
            value={name}
            onChange={(e) => setName(e.target.value)}
            className="w-full p-3 border rounded-lg focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <button className="bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700">
          Create Campaign
        </button>

      </form>
    </div>
  );
}

export default AddCampaign;
